import { useMediaQuery } from "@react-hooks-library/core";
import { SanityReference } from "next-sanity";
import { CSSProperties } from "react";
import TrackingPixel from "src/components/ads/TrackingPixel";
import CmsImageForAssetRef from "src/components/images/CmsImageForAssetRef";
import { getOrgSize } from "src/components/images/imageFunctions";
import StreamingguideLogo from "src/components/streaming/StreamingguideLogo";
import FilmwebLogoSvg from "src/components/svg/FilmwebLogoSvg";
import styles from "./TopOfPageSponsor.module.css";
import classNames from "classnames";

//#region [Props]
type TopOfPageSponsorProps = {
    mobileImages?: SanityReference[] | null;
    desktopImages?: SanityReference[] | null;
    clickUrl?: string | null;
    sponsorText?: "none" | "streaming" | "filmweb";
    hideSponsorTextMobile?: boolean;
    className?: string;
};
//#endregion

//#region [Component]
export default function TopOfPageSponsor({ className, mobileImages, desktopImages, clickUrl, sponsorText = "none", hideSponsorTextMobile = false }: TopOfPageSponsorProps) {
    const isDesktop = useMediaQuery("(min-width: 550px)");
    if (!mobileImages && !desktopImages) return null;

    const desktopSizes = desktopImages?.map(img => getOrgSize(img._ref));
    const mobileSizes = mobileImages?.map(img => getOrgSize(img._ref));
    const ccstyles: any = { "--sponsor-flex": (sponsorText !== "none" ? "50%" : "100%") };
    if (!!desktopSizes && desktopSizes.length > 0) {
        ccstyles["--sponsor-height-d"] = `${desktopSizes[0].height}px`;
        ccstyles["--sponsor-flex"] = `${desktopSizes[0].width}px`;
    }

    if (!!mobileSizes && mobileSizes.length > 0) {
        ccstyles["--sponsor-height-m"] = `${mobileSizes[0].height}px`;
    }

    const hasDesktopImages = (desktopImages?.length ?? 0) > 0;
    const hasMobileImages = (mobileImages?.length ?? 0) > 0;



    return <div className={classNames(styles.STopOfPageSponsorOuterContainer, className)}>
        <div style={ccstyles as CSSProperties} className={classNames("topOfPageSponsorInnerContainer", styles.STopOfPageSponsorContainer)} >
            {sponsorText === "streaming" && <div className={classNames(styles.SSGLogo, { [styles.hideSponsorTextMobile]: hideSponsorTextMobile })}>
                <StreamingguideLogo className={styles.SStreamingguideLogo} />
                <div className={styles.SCooperation}>i samarbeid med</div>
            </div>}
            {sponsorText === "filmweb" && <div className={classNames(styles.SSGLogo, { [styles.hideSponsorTextMobile]: hideSponsorTextMobile })}>
                <FilmwebLogoSvg className={styles.SFilmwebLogoSvg} />
                <div className={styles.SCooperation}>i samarbeid med</div>
            </div>}
            {(!!clickUrl ? (
                <a href={clickUrl!} target="_blank" className={classNames(styles.SSponsorLink, sponsorText !== 'none' ? styles.streamingguideSponsor : styles.sponsor)}>
                    {hasMobileImages && <CmsImageForAssetRef className={styles.SMobileCmsImageForAssetRef} assetRef={mobileImages![0]._ref} alt="Sponsorat" />}
                    {hasDesktopImages && <CmsImageForAssetRef className={styles.SDesktopCmsImageForAssetRef} assetRef={desktopImages![0]._ref} alt="Sponsorat" unoptimized />}
                </a>
            ) : (
                <div className={classNames(styles.SSponsorLink, sponsorText !== 'none' ? styles.streamingguideSponsor : styles.sponsor)}>
                    {hasMobileImages && <CmsImageForAssetRef className={styles.SMobileCmsImageForAssetRef} assetRef={mobileImages![0]._ref} alt="Sponsorat" />}
                    {hasDesktopImages && <CmsImageForAssetRef className={styles.SDesktopCmsImageForAssetRef} assetRef={desktopImages![0]._ref} alt="Sponsorat" unoptimized />}
                </div>
            ))}

        </div>
        {((isDesktop && hasDesktopImages) || (!isDesktop && hasMobileImages)) && <TrackingPixel className={styles.STrackingPixel} targetId="SponsorTrackingPixel" />}
    </div>;
}
//#endregion

//#region [Styles]
// Moved to TopOfPageSponsor.module.css
//#endregion
